import setQuestionType from '@/helpers/questions/question-sets/set-question-type'

const questions = setQuestionType()
export default questions
